import ScrollControl from "./ScrollControl";

const Scene = () => {
  return (
    <>
      
      

      {/* <CameraControl />*/}
      {/* <OrbitControl />  */}
       {/* <PresentationControl />  */}
      <ScrollControl />
      
      {/* <TransformControl /> */}
      {/* <PivotControl /> */}
      {/* <Modeltest /> */}
    </>
  );
};

export default Scene;
